import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetHardwareList = function () {
    return useApiCall(function (signal) { return api.hardware.apiHardwareDataGet(undefined, undefined, { signal: signal }); }, [], true, []);
};
